import { c as _c } from "react/compiler-runtime";
import React, { createContext, useState } from "react";
import { ActivityIndicator } from "./ActivityIndicator/ActivityIndicator";
export const ActivityContext = createContext<{
  activity: boolean;
  setActivity: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  activity: false,
  setActivity: () => {}
});
export const ActivityProvider: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [activity, setActivity] = useState(false);
  let t1;
  if ($[0] !== activity) {
    t1 = <ActivityIndicator active={activity} />;
    $[0] = activity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const indicator = t1;
  let t2;
  if ($[2] !== activity) {
    t2 = {
      activity,
      setActivity
    };
    $[2] = activity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== indicator || $[6] !== t2) {
    t3 = <ActivityContext.Provider value={t2}>{indicator}{children}</ActivityContext.Provider>;
    $[4] = children;
    $[5] = indicator;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};